import { createContext, useState } from 'react';
import { TabProps } from '../../../../blocks/tabs-vertical/TabsVertical';
import { DetailStep, PayloadAction } from './TaskDetailsReducer';
import { Container, Section, SectionHeader } from '../../../../styling/FormStyling';
import { StyledSectionContent } from './MeterTaskDetailsStep';
import TextRow from '../components/TextRow';
import { ContactInfo } from '../../../../api/api';
import { AddIcon } from '../../../../assets/icons/AddIcon';
import styled from 'styled-components';
import IconButton from '../../../../components/icon-button/IconButton';
import AddContactPersonDialog from './AddContactPersonDialog';
import { getEnumDisplayValue } from '../../../../utils/enumUtils';
import { formatAddress } from '../../../../utils/location/locationHandling';

interface Props extends TabProps {
  contactPersons?: ContactInfo[];
  workTaskId?: number;
  addContactCallback: (newContact: ContactInfo) => void;
}

export const TaskDetailsContext = createContext<DetailStep>({});
export const TaskDetailsDispatchContext = createContext<React.Dispatch<PayloadAction>>(() => {});

const ContactPersons = (props: Props) => {
  const { contactPersons, workTaskId, addContactCallback } = props;

  const [openDialog, setOpenDialog] = useState(false);

  return (
    <>
      {openDialog && (
        <AddContactPersonDialog
          workTaskId={workTaskId}
          handleClose={() => setOpenDialog(false)}
          addContactCallback={addContactCallback}
        />
      )}
      <Container>
        <Section>
          <SectionHeader>
            <Row>
              Kontaktpersoner
              <IconButton onClick={() => setOpenDialog(true)}>
                <AddIcon size="20px" />
              </IconButton>
            </Row>
          </SectionHeader>
          {contactPersons?.map((person) => (
            <StyledSectionContent>
              <ContactPersonContainer>
                {person.name && person.contactType && (
                  <TextRow
                    inputMode={false}
                    type="text"
                    label="Navn"
                    value={`${person.name} (${getEnumDisplayValue(person.contactType)}) `}
                  />
                )}
                {person.address && 
                    (person.address.streetName ||
                    person.address.houseNumber ||
                    person.address.cityName) && (
                  <TextRow
                    inputMode={false}
                    type="text"
                    label="Adresse"
                    value={formatAddress(person.address)}
                  />
                )}
                {person.phoneNumber && (
                  <TextRow inputMode={false} type="text" label="Telefonnummer" value={person.phoneNumber} />
                )}
                {person.email && <TextRow inputMode={false} type="text" label="Email" value={person.email} />}
                {person.companyName && <TextRow inputMode={false} type="text" label="Firma" value={person.companyName} />}
                {person.details && (
                  <TextRow inputMode={false} type="text" label="Yderligere information" value={person.details} />
                )}
              </ContactPersonContainer>
            </StyledSectionContent>
          ))}
        </Section>
      </Container>
    </>
  );
};

const Row = styled.div`
  display: flex;
  align-items: center;
`;

const ContactPersonContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid lightgrey;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 20px;
`;

export default ContactPersons;
